import { Divider, VStack } from '@cad-arc';
import { UnitStatusSearchOptions } from '@mark43/cad-api';
import { UseFormReturn } from 'react-hook-form';
import { UnitStatusSearchFormType } from './types';
import { UnitStatusSearchFormEventRelatedSection } from './unit-status-search-form-event-related-section';
import { UnitStatusSearchFormGeneralSection } from './unit-status-search-form-general-section';
import { UnitStatusSearchFormStatusesSection } from './unit-status-search-form-statuses-section';
import { SearchFormLocationSection } from '../search-windows/search-form-location-section';

export function UnitStatusSearchFormBody({
    form,
    options,
}: {
    form: UseFormReturn<UnitStatusSearchFormType>;
    options: UnitStatusSearchOptions;
}) {
    return (
        <VStack gap="20px" align="left">
            <UnitStatusSearchFormGeneralSection form={form} options={options} />
            <Divider />
            <UnitStatusSearchFormStatusesSection form={form} options={options} />
            <Divider />
            <SearchFormLocationSection
                title="Involved Location"
                options={options}
                hideLocationVerificationField
            />
            <Divider />
            <UnitStatusSearchFormEventRelatedSection form={form} options={options} />
        </VStack>
    );
}
